var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_1234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.96063e-05C10.7873 2.96063e-05 6.99803 2.96063e-05 3.99831 2.96063e-05C1.78916 2.96063e-05 9.41058e-06 1.7909 2.10191e-05 4.00005L0.000105095 20C0.000116703 22.2092 1.79097 24 4.0001 24H20C22.2091 24 24 22.2091 24 20L23.9999 3.99999C23.9999 1.79086 22.2107 5.35369e-06 20.0016 1.14834e-05C17.0019 1.98067e-05 13.2127 2.96063e-05 12 2.96063e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33032 14.9097C6.84356 15.3964 6.84356 16.1856 7.33032 16.6724C7.81707 17.1591 8.60625 17.1591 9.09301 16.6724L16.6726 9.0928C17.1592 8.60612 17.1594 7.81683 16.6726 7.33007C16.1858 6.84332 15.3966 6.84343 14.9099 7.33012L7.33032 14.9097Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09008 7.32861C8.60333 6.84185 7.81415 6.84185 7.3274 7.32861C6.84064 7.81536 6.84064 8.60454 7.3274 9.0913L14.907 16.6709C15.3936 17.1575 16.1829 17.1577 16.6697 16.6709C17.1564 16.1841 17.1563 15.3949 16.6696 14.9082L9.09008 7.32861Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_1234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.40c22171f18a734c788d4bdd6b50a45a.svg";
export { ForwardRef as ReactComponent };